<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-card class="px-0 size">
                <v-row class="px-4 pb-1 mt-1">
                    <v-col cols="8">
                        <v-tabs v-model="tab" align-with-title backgroundColor="background" active-class="active_tab">
                            <v-tabs-slider color="secondary"></v-tabs-slider>
                            <v-tab v-for="item in tab_items" :key="item" class="non_selected_tab">
                                {{ item }}
                            </v-tab>
                        </v-tabs>
                    </v-col>
                    <v-col cols="4" class="pb-0 mt-1">
                        <datepicker :open_dialog="date_modal" :model="today_date" @model="updateDate"
                            :label="$t('backlog.date')" v-if="tab == 0 && today_date != ''" :rules_required="rules_required" style="max-height: 40px; min-height: 40px; height: 40px;">
                        </datepicker>
                        <v-text-field v-else-if="tab != 0" class="py-0" v-model="today_date" :label="$t('backlog.date')" readonly></v-text-field>
                    </v-col>
                </v-row>
                <v-card-text class="py-3">
                    <v-row>
                        <v-col cols="12">
                            <v-tabs-items v-model="tab">
                                <v-tab-item>
                                    <v-row class="mt-0">
                                        <v-col class="py-0" cols="6">
                                            <v-row v-if="$vuetify.theme.dark"
                                                class="font-weight-bold text-uppercase accent--text py-1 my-0 mx-0"
                                                style="background-color: #001F5B;" justify="center" align="center">
                                                {{ $t("backlog.pending_operations") }}: {{ pending_operations }}
                                            </v-row>
                                            <v-row v-else-if="!$vuetify.theme.dark"
                                                class="font-weight-bold text-uppercase white_highlight--text py-1 my-0 mx-0"
                                                style="background-color: #001F5B;" justify="center" align="center">
                                                {{ $t("backlog.pending_operations") }}: {{ pending_operations }}
                                            </v-row>
                                        </v-col>
                                        <v-col class="py-0" cols="6">
                                            <v-row v-if="$vuetify.theme.dark"
                                                class="font-weight-bold text-uppercase accent--text py-1 my-0 mx-0"
                                                style="background-color: #001F5B;" justify="center" align="center">
                                                {{ $t("backlog.pending_storage") }}: {{ pending_storage }}
                                            </v-row>
                                            <v-row v-else-if="!$vuetify.theme.dark"
                                                class="font-weight-bold text-uppercase white_highlight--text py-1 my-0 mx-0"
                                                style="background-color: #001F5B;" justify="center" align="center">
                                                {{ $t("backlog.pending_storage") }}: {{ pending_storage }}
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4">
                                        <v-col class="py-0" cols="12">
                                            <v-row
                                                class="blue_accent font-weight-bold text-uppercase white_highlight--text py-1 my-0 mx-0"
                                                justify="center" align="center">
                                                {{ $t("backlog.storage") }}
                                            </v-row>

                                            <v-data-table class="px-0 my-2" no-results-text="No hay resultados"
                                                :headers="headers_storage" :items="props_storage.items" calculate-widths
                                                :hide-default-footer="true" :mobile-breakpoint="0" disable-pagination
                                                item-key="id">
                                                <template v-slot:item.status="{ item }">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <td style="text-align: center; text-transform: uppercase;"
                                                                v-on="on"
                                                                v-if="item.status != 'Pendiente Anexo24' && item.status != 'Completo' && item.status != 'Completed'">
                                                                <span class="back_orange"> {{ $t('backlog.pending') }}
                                                                </span>
                                                            </td>
                                                            <td style="text-align: center; text-transform: uppercase;"
                                                                v-else v-on="on">
                                                                <span class="back_green"> {{ $t('backlog.completed') }}
                                                                </span>
                                                            </td>
                                                        </template>

                                                        <span
                                                            v-if="item.status != 'Pendiente Anexo24' && item.status != 'Completo' && item.status != 'Completed'">{{
                                                                $t('backlog.pending') }}</span>
                                                        <span v-else>{{ $t('backlog.completed') }}</span>
                                                    </v-tooltip>
                                                </template>

                                                <v-data-footer :items-per-page-options="[]"></v-data-footer>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-row class="mt-0">
                                        <v-col class="py-0" cols="12">
                                            <v-row
                                                class="blue_accent font-weight-bold text-uppercase white_highlight--text py-1 my-0 mx-0"
                                                justify="center" align="center">
                                                {{ $t("backlog.fulfillment") }}
                                            </v-row>

                                            <datatable :props="{headers:headers_fulfillment, items: props_fulfillment.items, search: ''}" :hide_pagination="true" disable-pagination @open-item="itemClicked"></datatable>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color"
            style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>

        <v-dialog v-model="modal_to_show" persistent max-width="90%">
            <v-card >
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center">
                            <h3 class="text-uppercase my-4 mx-3">
                                {{ modal_title }}
                            </h3>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                        <v-col cols="12">
                            <datatable :props="{headers:headers_ff_details, items: ff_details, search: ''}" :hide_pagination="true" disable-pagination></datatable>
                        </v-col>
                    </v-row>
                    
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn class="mx-3" text @click="modal_to_show = false">{{ $t('backlog.cancel') }}</v-btn>
                    </div>
                </v-card-text> 
                <div class="marker1"></div>
            </v-card>
        </v-dialog>
        
    </div>
</template>

<script>
import { HttpBacklogRepository } from '../infrastructure/backlog_repository';
import { backlogGetBacklogStorageUseCase } from '../application/use_cases/backlog_get_backlog_storage_use_case';
import { backlogGetBacklogFulfillmentUseCase } from '../application/use_cases/backlog_get_backlog_fulfillment_use_case';
import { backlogShowFFDetailsUseCase } from '../application/use_cases/backlog_show_ff_details_use_case';

export default {
    computed: {
        rules_required() { return [v => !!v || this.$t('create_appointment.validations.required_field')] },
        headers_storage() {
            return [
                // { text: this.$t('backlog.id'), align: "center", value: 'appointment_id', class: 'text-uppercase' },
                { text: this.$t('backlog.customer'), align: "center", value: 'client_name', class: 'text-uppercase' },
                { text: this.$t('backlog.operation'), align: "center", value: 'description', class: 'text-uppercase' },
                { text: this.$t('backlog.container'), align: "center", value: 'container_number', class: 'text-uppercase' },
                { text: this.$t('backlog.user'), align: "center", value: 'users_name', class: 'text-uppercase' },
                { text: this.$t('backlog.pending_activity'), align: "center", value: 'pending_operation', class: 'text-uppercase' },
                { text: '', align: "center", value: 'status', class: 'text-uppercase' }
            ];
        },
        headers_fulfillment() {
            return [
                { text: this.$t('backlog.customer'), align: "center", value: 'client_name', class: 'text-uppercase' },
                { text: this.$t('backlog.cutoff_time'), align: "center", value: 'cutoff_time', class: 'text-uppercase' },
                { text: this.$t('backlog.type'), align: "center", value: 'type', class: 'text-uppercase' },
                { text: this.$t('backlog.in_time'), align: "center", value: 'in_time', class: 'text-uppercase' },
                { text: this.$t('backlog.late'), align: "center", value: 'late', class: 'text-uppercase' },
                { text: this.$t('backlog.processed'), align: "center", value: 'processed', class: 'text-uppercase' },
                { text: this.$t('backlog.without_stock'), align: "center", value: 'without_stock', class: 'text-uppercase' }
            ]
        },
        headers_ff_details() {
            return [
                { text: this.$t('backlog.customer'), align: "center", value: 'cliente', class: 'text-uppercase' },
                { text: this.$t('backlog.order'), align: "center", value: 'orden', class: 'text-uppercase' },
                { text: this.$t('backlog.shipping_service'), align: "center", value: 'paqueteria', class: 'text-uppercase' },
                { text: this.$t('backlog.condition'), align: "center", value: 'condicion', class: 'text-uppercase' }
            ]
        }
    },
    data() {
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            date_modal: false,
            props_storage: {
                search: '',
                items: [],
            },
            props_fulfillment: {
                searhc: '',
                items: []
            },
            today_date: '',
            pending_operations: "",
            pending_storage: "",
            tab_items: [ this.$t('backlog.storage'), this.$t('backlog.fulfillment') ],
            tab: this.$t('backlog.storage'),
            item_to_show: '',
            modal_to_show: false,
            modal_title: '',
            ff_details: []
        }
    },
    mounted() {
        this.today_date = new Date();
        this.today_date = this.today_date.getFullYear() + '-' +
            String(this.today_date.getMonth() + 1).padStart(2, '0') + '-' +
            String(this.today_date.getDate()).padStart(2, '0');
        this.$store.state.module = "headers.backlog";
    },
    methods: {
        methodHandler(object) {
            this[object.methodName](object.parameters)
        },
        updateDate(newDate) {
            this.today_date = newDate; // Actualiza la fecha en el padre
        },
        async index_storage() {
            this.props_storage.items = [];
            this.props_fulfillment.items = [];

            try {
                const result = await backlogGetBacklogStorageUseCase(this.today_date, HttpBacklogRepository);

                this.props_storage.items = result.storage;
                this.pending_operations = result.pending_operations.total;
                this.pending_storage = result.pending_storage.total;
            } 
            catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async index_fulfillment() {
            this.props_storage.items = [];
            this.props_fulfillment.items = [];

            try {
                const result = await backlogGetBacklogFulfillmentUseCase(this.today_date, HttpBacklogRepository);

                this.props_fulfillment.items = result.fulfillment;
            } 
            catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async itemClicked(obj) {
            this.modal_to_show = true;

            if(obj.type == "in_time") {
                if(obj.item.type == "cod") this.modal_title = this.$t('backlog.titles.in_time_cod');
                else if(obj.item.type == "regular") this.modal_title = this.$t('backlog.titles.in_time_regular');
                else if(obj.item.type == "fulfillment") this.modal_title = this.$t('backlog.titles.in_time_fulfillment');
            }
            else if(obj.type == "late") {
                if(obj.item.type == "cod") this.modal_title = this.$t('backlog.titles.late_cod');
                else if(obj.item.type == "regular") this.modal_title = this.$t('backlog.titles.late_regular');
                else if(obj.item.type == "fulfillment") this.modal_title = this.$t('backlog.titles.late_fulfillment');
            }
            else if(obj.type == "processed") {
                if(obj.item.type == "cod") this.modal_title = this.$t('backlog.titles.processed_cod');
                else if(obj.item.type == "regular") this.modal_title = this.$t('backlog.titles.processed_regular');
                else if(obj.item.type == "fulfillment") this.modal_title = this.$t('backlog.titles.processed_fulfillment');
            }
            else if(obj.type == "without_stock") {
                if(obj.item.type == "cod") this.modal_title = this.$t('backlog.titles.without_stock_cod');
                else if(obj.item.type == "regular") this.modal_title = this.$t('backlog.titles.without_stock_regular');
            }

            this.ff_details = [];

            try {
                const result = await backlogShowFFDetailsUseCase(obj.item.client_name, obj.item.type, obj.type, HttpBacklogRepository);

                this.ff_details = result;
            } 
            catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }

        }
    },
    watch: {
        'today_date': async function () {
            if(this.tab_items[this.tab] == this.$t('backlog.storage')) await this.index_storage();
            else if(this.tab_items[this.tab] == this.$t('backlog.fulfillment')) await this.index_fulfillment();
        },
        'tab': async function () {
            if(this.tab_items[this.tab] == this.$t('backlog.storage')) await this.index_storage();
            else if(this.tab_items[this.tab] == this.$t('backlog.fulfillment')) await this.index_fulfillment();
        }
    }
}
</script>

<style></style>